import {Divider} from "@/components/divider/Divider.tsx";
import {formatDurationRounded} from "@/pages/statuspages/consumption/utils/uptimeBarEvents.ts";

import styles from "./StatusPageUptimeBarTooltip.module.scss";

interface IncidentListSectionProps {
  title: string;
  items: Array<{id: number; name: string; duration: number}>;
  maxListLength: number;
}

export const IncidentListSection = ({title, items, maxListLength}: IncidentListSectionProps) => {
  if (items.length === 0) return null;
  return (
    <>
      <Divider />
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{`${title} (${items.length})`}</div>
        <div className={styles.itemList}>
          {items.slice(0, maxListLength).map((inc) => (
            <div key={inc.id} className={styles.incidentItem}>
              {inc.name}
              <span className={styles.durationText}>({formatDurationRounded(inc.duration)})</span>
            </div>
          ))}
          {items.length > maxListLength && <div className={styles.moreText}>+ {items.length - maxListLength} more</div>}
        </div>
      </div>
    </>
  );
};
